import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user_profile } from "../../actions/auth";
import { NavWrap } from "../ShopForTyres";
import "./style.css";
import { get_addresses } from "../../actions/orders";
import _ from "lodash";
const Profile = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.auth?.profile?.data?.customer);
  const addresses = useSelector((state) => state?.orders?.addresses?.data);

  useEffect(() => {
    dispatch(
      user_profile({
        email: localStorage.getItem("email"),
      })
    );
    let obj = {
      email: localStorage.getItem("email"),
    };

    dispatch(get_addresses(obj));
    // eslint-disable-next-line
  }, []);
  const s_email = localStorage.getItem("s_email");
  const addr = profile?.shipping_addresses?.[0];
  return (
    <NavWrap>
      <div className="profile">
        <h3>
          My Profile
          {/* <span className="ml1">|</span>{" "} */}
          {/* <span className="ml1">ID: 60004617314</span> */}
        </h3>
        <p className="note">
          Please{" "}
          <a
            className="cursor link"
            href="https://www.omni-united.com/contact-us"
            target="_blank"
            rel="noreferrer"
          >
            contact us
          </a>{" "}
          , if you would like to change the below details.
        </p>
        <div>
          <div className="d-flex" style={{ gap: "2rem" }}>
            <div className="w50">
              <div className="row">
                <span className="label">Company Name</span>
                <span className="value w60">{addr?.name}</span>
              </div>
              {/* <div className="row">
            <span className="label">Company Location</span>
            <span className="value w60">{addr?.}</span>
          </div> */}
              {s_email && (
                <div className="row">
                  <span className="label">Support</span>
                  <span className="value w60">{s_email}</span>
                </div>
              )}
              <div className="row">
                <span className="label">Primary Contact</span>
                <span className="value w60">{profile?.email}</span>
              </div>
              <div className="row">
                <span className="label">Contact Number</span>
                <span className="value w60">{profile?.phone || "-"}</span>
              </div>
              <div className="row">
                <span className="label">IncoTerms</span>
                <span className="value w60">{profile?.inco1_txt || "-"}</span>
              </div>
              <div className="row">
                <span className="label">Payment Term</span>
                <span className="value w60">{profile?.zterm_txt || "-"}</span>
              </div>
            </div>
            <div className="w50">
              <div className="row">
                <span className="label">Company Address</span>
                <span className="value w60">{addr?.address1}</span>
              </div>
              <div className="row">
                <span className="label"></span>
                <span className="value w60">
                  {addr?.address2} {addr?.city} {addr?.state}
                </span>
              </div>
              <div className="row">
                <span className="label"></span>
                <div className="d-flex w60">
                  {/* <span className="value">Jurong</span>
              <span className="value">Singapore</span> */}
                  <span className="value">{addr?.zip}</span>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <span className="label"></span>
            <div className="d-flex w50">
              <span className="value">+65 66788990</span>
              <span className="value empty"></span>
              <span className="value empty"></span>
            </div>
          </div> */}
          <h3>Shipping Addresses</h3>
          {/* <p className="note">
            Shipping Addresses can only be modified by the moderator in the SAP
            system. Please contact administrator.
          </p> */}
          <div className="contact-address mt1 pb2">
            {addresses &&
              Array.isArray(addresses) &&
              _.unionBy(addresses, "sap_ref")?.map((ele) => (
                <div className="address-card mr2">
                  <h2 className="flex-between">
                    <span>{ele.name}</span>
                    {/* <span className="green">Primary</span> */}
                  </h2>
                  <p>
                    {/* {ele.name} <br /> */}
                    {ele.address1 ? (
                      <>
                        {ele.address1},<br />
                      </>
                    ) : null}
                    {ele.address2 ? (
                      <>
                        {ele.address2},<br />
                      </>
                    ) : null}
                    {ele.city ? (
                      <>
                        {ele.city},<br />
                      </>
                    ) : null}
                    {ele.state ? (
                      <>
                        {ele.state},<br />
                      </>
                    ) : null}
                    {ele.zip ? (
                      <>
                        {ele.zip},<br />
                      </>
                    ) : null}
                    {ele.phone ? (
                      <>
                        PH : {ele.phone},<br />
                      </>
                    ) : null}
                  </p>
                </div>
              ))}
            {/* <div className="address-card w60">
              <h2 className="flex-between">
                <span>STMP Singapore 1</span>
                <span className="blue">Make Primary</span>
              </h2>
              <p>
                Mike <br />
                Telecommunications Limited. <br />
                31 Exeter Road, <br />
                Comcentre, <br /> Singapore 239732 <br /> +61 990909000
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </NavWrap>
  );
};

export default Profile;
